export default "__VITE_ASSET__BWrKn4eL__"